<template>
    <div>
        <div class="card">
            <div class="card-header">
                <h3>Risk Calculator 
                    <strong v-if="weakness.risk == 'High' || weakness.risk == 'Very high'" class="text-danger">({{ weakness.risk }})</strong>
                    <span v-else class="text-primary">({{ weakness.risk }})</span>
                </h3>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <strong>Impact</strong>
                        <ul class="impact radio">
                            <li><label><input type="radio" name="impact" v-model="weakness.impact" value="Negligible"> Negligible</label></li>
                            <li><label><input type="radio" name="impact" v-model="weakness.impact" value="Marginal"> Marginal</label></li>
                            <li><label><input type="radio" name="impact" v-model="weakness.impact" value="Moderate"> Moderate</label></li>
                            <li><label><input type="radio" name="impact" v-model="weakness.impact" value="Critical"> Critical</label></li>
                            <li><label><input type="radio" name="impact" v-model="weakness.impact" value="Catastrophic"> Catastrophic</label></li>
                        </ul>
                    </div>
                    <div class="col-md-3">
                        <strong>Likelihood</strong>
                        <ul class="impact radio">
                            <li><label><input type="radio" name="likelihood" v-model="weakness.likelihood" value="Rare"> Rare</label></li>
                            <li><label><input type="radio" name="likelihood" v-model="weakness.likelihood" value="Unlikely"> Unlikely</label></li>
                            <li><label><input type="radio" name="likelihood" v-model="weakness.likelihood" value="Possible"> Possible</label></li>
                            <li><label><input type="radio" name="likelihood" v-model="weakness.likelihood" value="Likely"> Likely</label></li>
                            <li><label><input type="radio" name="likelihood" v-model="weakness.likelihood" value="Certain"> Certain</label></li>
                        </ul>
                    </div>
                    <div class="col-md-3">
                        <strong>Fix Effort</strong>
                        <ul class="impact radio">
                            <li><label><input type="radio" name="fixeffort" v-model="weakness.fixeffort" value="Low"> Low</label></li>
                            <li><label><input type="radio" name="fixeffort" v-model="weakness.fixeffort" value="Medium"> Medium</label></li>
                            <li><label><input type="radio" name="fixeffort" v-model="weakness.fixeffort" value="High"> High</label></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            impact: String,
            likelihood: String,
            fixeffort: String,
            risk: String
        },
        data() {
            return {
                weakness: {
                    impact: 'Moderate',
                    likelihood: 'Possible',
                    fixeffort: 'Low',
                    risk: 'Medium',
                }
            }
        },
        mounted() {
            this.weakness.impact = this.impact;
            this.weakness.likelihood = this.likelihood;
            this.weakness.fixeffort = this.fixeffort;
            this.weakness.risk = this.risk;
        },
        methods: {
            riskCal(likelihood, impact) {
                let risk = '';
                if (likelihood == "Certain" && impact == "Negligible") {
                    risk = "Low";
                } else if (likelihood == "Likely" && impact == "Negligible") {
                    risk = "Low";
                } else if (likelihood == "Possible" && impact == "Negligible") {
                    risk = "Insignificant";
                } else if (likelihood == "Unlikely" && impact == "Negligible") {
                    risk = "Insignificant";
                } else if (likelihood == "Rare" && impact == "Negligible") {
                    risk = "Insignificant";
                } else if (likelihood == "Certain" && impact == "Marginal") {
                    risk = "Medium";
                } else if (likelihood == "Likely" && impact == "Marginal") {
                    risk = "Low";
                } else if (likelihood == "Possible" && impact == "Marginal") {
                    risk = "Low";
                } else if (likelihood == "Unlikely" && impact == "Marginal") {
                    risk = "Low";
                } else if (likelihood == "Rare" && impact == "Marginal") {
                    risk = "Insignificant";
                } else if (likelihood == "Certain" && impact == "Moderate") {
                    risk = "High";
                } else if (likelihood == "Likely" && impact == "Moderate") {
                    risk = "Medium";
                } else if (likelihood == "Possible" && impact == "Moderate") {
                    risk = "Medium";
                } else if (likelihood == "Unlikely" && impact == "Moderate") {
                    risk = "Medium";
                } else if (likelihood == "Rare" && impact == "Moderate") {
                    risk = "Low";
                } else if (likelihood == "Certain" && impact == "Critical") {
                    risk = "Very high";
                } else if (likelihood == "Likely" && impact == "Critical") {
                    risk = "High";
                } else if (likelihood == "Possible" && impact == "Critical") {
                    risk = "High";
                } else if (likelihood == "Unlikely" && impact == "Critical") {
                    risk = "High";
                } else if (likelihood == "Rare" && impact == "Critical") {
                    risk = "Medium";
                } else if (likelihood == "Certain" && impact == "Catastrophic") {
                    risk = "Very high";
                } else if (likelihood == "Likely" && impact == "Catastrophic") {
                    risk = "Very high";
                } else if (likelihood == "Possible" && impact == "Catastrophic") {
                    risk = "Very high";
                } else if (likelihood == "Unlikely" && impact == "Catastrophic") {
                    risk = "Very high";
                } else if (likelihood == "Rare" && impact == "Catastrophic") {
                    risk = "High";
                } else {
                    risk = '';
                }
                this.weakness.risk = risk;
                this.$emit('callback', this.weakness)
            }
        },
        watch: {
            'weakness.impact'(val) {
                this.riskCal(this.weakness.likelihood, val);
            },
            'weakness.likelihood'(val) {
                this.riskCal(val, this.weakness.impact);
            },
            'weakness.fixeffort' () {
                this.$emit('callback', this.weakness);
            }
        },
    }
</script>